/**
 * Contact Section – reCAPTCHA Integration
 */
(function () {
  var section = document.querySelector('.shopify-section--contact');
  if (!section) return;

  var siteKey = section.querySelector('[data-recaptcha-sitekey]');
  if (!siteKey) return;

  var key = siteKey.getAttribute('data-recaptcha-sitekey');
  if (!key) return;

  var containerId = siteKey.id;

  function renderWidget() {
    if (typeof grecaptcha !== 'undefined' && grecaptcha.render) {
      try {
        grecaptcha.render(containerId, { sitekey: key });
      } catch (e) {
        /* widget already rendered */
      }
    }
  }

  if (typeof grecaptcha !== 'undefined' && grecaptcha.render) {
    renderWidget();
  } else {
    window.onContactRecaptchaLoad = renderWidget;

    var script = document.createElement('script');
    script.src = 'https://www.google.com/recaptcha/api.js?onload=onContactRecaptchaLoad&render=explicit';
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
  }
})();
